// Taken from
// https://github.com/onderceylan/pwa-asset-generator/blob/master/src/config/apple-fallback-data.json
export function isIos() {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
}
export function isPWA() {
    // @ts-ignore
    if (navigator === null || navigator === void 0 ? void 0 : navigator.standalone) {
        return true;
    }
    try {
        const isStandalone = window.matchMedia("(display-mode: standalone)").matches;
        if (document.referrer.startsWith("android-app://")) {
            return true; // 'twa';
        }
        else if (isStandalone) {
            return true; // 'standalone';
        }
    }
    catch (e) {
        console.log(e);
    }
    return false;
}
export function listenDevicePWAChange(cb) {
    try {
        // Detect if changes if running in standalone or browser
        // https://web.dev/customize-install/
        window.matchMedia("(display-mode: standalone)").addEventListener("change", (evt) => {
            cb(evt.matches);
        });
    }
    catch (e) {
        console.log("Error listening for change between PWA and website");
        console.log(e);
    }
}
export const deviceListIos = [
    {
        device: "12.9 iPad Pro",
        portrait: {
            width: 2048,
            height: 2732,
        },
        landscape: {
            width: 2732,
            height: 2048,
        },
        scaleFactor: 2,
    },
    {
        device: "11 iPad Pro",
        portrait: {
            width: 1668,
            height: 2388,
        },
        landscape: {
            width: 2388,
            height: 1668,
        },
        scaleFactor: 2,
    },
    {
        device: "10.5 iPad Pro",
        portrait: {
            width: 1668,
            height: 2388,
        },
        landscape: {
            width: 2388,
            height: 1668,
        },
        scaleFactor: 2,
    },
    {
        device: "9.7 iPad Pro",
        portrait: {
            width: 1536,
            height: 2048,
        },
        landscape: {
            width: 2048,
            height: 1536,
        },
        scaleFactor: 2,
    },
    {
        device: "7.9 iPad mini",
        portrait: {
            width: 1536,
            height: 2048,
        },
        landscape: {
            width: 2048,
            height: 1536,
        },
        scaleFactor: 2,
    },
    {
        device: "10.5 iPad Air",
        portrait: {
            width: 1668,
            height: 2224,
        },
        landscape: {
            width: 2224,
            height: 1668,
        },
        scaleFactor: 2,
    },
    {
        device: "9.7 iPad Air",
        portrait: {
            width: 1536,
            height: 2048,
        },
        landscape: {
            width: 2048,
            height: 1536,
        },
        scaleFactor: 2,
    },
    {
        device: "10.2 iPad",
        portrait: {
            width: 1620,
            height: 2160,
        },
        landscape: {
            width: 2160,
            height: 1620,
        },
        scaleFactor: 2,
    },
    {
        device: "9.7 iPad",
        portrait: {
            width: 1536,
            height: 2048,
        },
        landscape: {
            width: 2048,
            height: 1536,
        },
        scaleFactor: 2,
    },
    {
        device: "iPhone 12 Pro Max",
        portrait: {
            width: 1284,
            height: 2778,
        },
        landscape: {
            width: 2778,
            height: 1284,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 12 Pro",
        portrait: {
            width: 1170,
            height: 2532,
        },
        landscape: {
            width: 2532,
            height: 1170,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 12",
        portrait: {
            width: 1170,
            height: 2532,
        },
        landscape: {
            width: 2532,
            height: 1170,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 12 mini",
        portrait: {
            width: 1125,
            height: 2436,
        },
        landscape: {
            width: 2436,
            height: 1125,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 11 Pro Max",
        portrait: {
            width: 1242,
            height: 2688,
        },
        landscape: {
            width: 2688,
            height: 1242,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 11 Pro",
        portrait: {
            width: 1125,
            height: 2436,
        },
        landscape: {
            width: 2436,
            height: 1125,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 11",
        portrait: {
            width: 828,
            height: 1792,
        },
        landscape: {
            width: 1792,
            height: 828,
        },
        scaleFactor: 2,
    },
    {
        device: "iPhone XS Max",
        portrait: {
            width: 1242,
            height: 2688,
        },
        landscape: {
            width: 2688,
            height: 1242,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone XS",
        portrait: {
            width: 1125,
            height: 2436,
        },
        landscape: {
            width: 2436,
            height: 1125,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone XR",
        portrait: {
            width: 828,
            height: 1792,
        },
        landscape: {
            width: 1792,
            height: 828,
        },
        scaleFactor: 2,
    },
    {
        device: "iPhone X",
        portrait: {
            width: 1125,
            height: 2436,
        },
        landscape: {
            width: 2436,
            height: 1125,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 8 Plus",
        portrait: {
            width: 1242,
            height: 2208,
        },
        landscape: {
            width: 2208,
            height: 1242,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 8",
        portrait: {
            width: 750,
            height: 1334,
        },
        landscape: {
            width: 1334,
            height: 750,
        },
        scaleFactor: 2,
    },
    {
        device: "iPhone 7 Plus",
        portrait: {
            width: 1242,
            height: 2208,
        },
        landscape: {
            width: 2208,
            height: 1242,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 7",
        portrait: {
            width: 750,
            height: 1334,
        },
        landscape: {
            width: 1334,
            height: 750,
        },
        scaleFactor: 2,
    },
    {
        device: "iPhone 6s Plus",
        portrait: {
            width: 1242,
            height: 2208,
        },
        landscape: {
            width: 2208,
            height: 1242,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 6s",
        portrait: {
            width: 750,
            height: 1334,
        },
        landscape: {
            width: 1334,
            height: 750,
        },
        scaleFactor: 2,
    },
    {
        device: "iPhone 6 Plus",
        portrait: {
            width: 1242,
            height: 2208,
        },
        landscape: {
            width: 2208,
            height: 1242,
        },
        scaleFactor: 3,
    },
    {
        device: "iPhone 6",
        portrait: {
            width: 750,
            height: 1334,
        },
        landscape: {
            width: 1334,
            height: 750,
        },
        scaleFactor: 2,
    },
    {
        device: "4.7 iPhone SE",
        portrait: {
            width: 750,
            height: 1334,
        },
        landscape: {
            width: 1334,
            height: 750,
        },
        scaleFactor: 2,
    },
    {
        device: "4 iPhone SE",
        portrait: {
            width: 640,
            height: 1136,
        },
        landscape: {
            width: 1136,
            height: 640,
        },
        scaleFactor: 2,
    },
    {
        device: "iPod touch 5th generation and later",
        portrait: {
            width: 640,
            height: 1136,
        },
        landscape: {
            width: 1136,
            height: 640,
        },
        scaleFactor: 2,
    },
];
//# sourceMappingURL=device.js.map